<script lang="ts">
  import ModalPictureTextAction from '$components/modal-picture-text-action/ModalPictureTextAction.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import Button from '$components/button/Button.svelte';
  import ImageiOS from '$lib/assets/banner-open-in-browser-ios.webp';
  import ImageAndroid from '$lib/assets/banner-open-in-browser-android.webp';
  import platform from 'platform';

  let Image = ImageiOS;

  if (platform.os?.family !== 'iOS') {
    Image = ImageAndroid;
  }
</script>

<ModalPictureTextAction titleTestId="pwa-title-text" paragraphTestId="pwa-paragraph-text">
  {#snippet image()}
    <img src={Image} alt="Metri" class="mx-auto w-full" />
  {/snippet}
  {#snippet title()}
    Passkeys don't work here
  {/snippet}
  {#snippet paragraph()}
    It looks like you're opening Metri in an in-app browser. Passkeys require access to your
    device's built-in security features. <p class="mt-2">
      For the best experience with secure passkey authentication, please open this link in {platform
        .os?.family === 'iOS'
        ? 'Safari'
        : 'Chrome'}.
    </p>
  {/snippet}
  {#snippet action()}
    <Button ariaLabel="Close" stretched variant="secondary" onclick={closeModal}>Cancel</Button>
  {/snippet}
</ModalPictureTextAction>
